module.exports = __webpack_public_path__ + "img/04-1-1数据应用.bad9b0db.svg";